import { createSlice } from "@reduxjs/toolkit";
import { RevenueMeta, SessionBooking } from "../types";
import { doFetchRevenueList } from "./revenue.action";

interface RevenueState {
  bookings: SessionBooking[];
  meta: RevenueMeta | null;
  loading: boolean;
  error: string | null;
}
const initialState: RevenueState = {
  bookings: [],
  meta: null,
  loading: false,
  error: null,
};

export const revenueSlice = createSlice({
  name: "revenue",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(doFetchRevenueList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(doFetchRevenueList.fulfilled, (state, action) => {
        state.loading = false;
        state.bookings = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(doFetchRevenueList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default revenueSlice.reducer;
